<template>
  <b-modal id="modal-1" title="เพิ่มรายชื่อผู้ประสานงาน" @ok="submit" @hidden="clearForm">
    <b-alert variant="primary" show>
      <font-awesome-icon icon="info-circle" /> กรอกรหัสนักศึกษาและคลิกปุ่มค้นหา เพื่อตรวจสอบความถูกต้องก่อนเพิ่มลงในตาราง
    </b-alert>
    <b-form-group label-cols="4" label-cols-lg="3" label="รหัสนักศึกษา" label-for="input-default">
      <b-form-input v-model="form.studentId" />
    </b-form-group>
    <b-form-group label-cols="4" label-cols-lg="3" label="ปีการศึกษา" label-for="input-default">
      <b-form-input :value="addingToAcYear && addingToAcYear.year" disabled />
    </b-form-group>
  </b-modal>
</template>
<script>
import gql from 'graphql-tag'

export default {
  props: {
    addingToAcYear: { type: Object, default: () => ({ id: null, year: '' }) }
  },
  data () {
    return {
      form: {
        studentId: ''
      }
    }
  },
  methods: {
    async submit () {
      await this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!, $username: String!, $acYearId: ID!) { groupAddCoordinator(id: $id, username: $username, acYearId: $acYearId) { id } }`,
        variables: { id: this.$route.params.id, username: this.form.studentId, acYearId: this.addingToAcYear.id }
      }).then(() => {
        this.$bvToast.toast('เพิ่มผู้ประสานงานสำเร็จ', {
          title: 'สำเร็จ',
          variant: 'success',
          solid: true
        })
      })
        .catch(() => {
          this.$bvToast.toast('เกิดข้อผิดพลาดในการบันทึกข้อมูล ตรวจสอบการกรอกข้อมูลอีกครั้ง', {
            title: 'แจ้งเตือน',
            variant: 'danger',
            solid: true,
            noCloseButton: true
          })
        })

      this.$emit('finish')
    },
    clearForm () {
      this.form = {
        studentId: ''
      }
    }
  }
}
</script>
